// components/NCO/NcoGridHeader.tsx
import React from 'react'
import BoardsGridHeader from 'components/DataGrid/BoardsGridHeader'
import type { OrganizationTableItem } from 'types'

type Props = {
  organization: OrganizationTableItem | null
  deal: any // If you have a typed Deal/NewDeal, feel free to tighten this
}

/**
 * Slim wrapper so Drawer_NCO stays lean and we can customize NCO-specific header bits later.
 */
const NcoGridHeader: React.FC<Props> = ({ organization, deal }) => {
  return <BoardsGridHeader newDeal={deal} organization={organization} />
}

export default React.memo(NcoGridHeader)
